import { create } from 'zustand';

import { ITrueLayerReport } from '../types';

interface IInternalStore {
	accounts: ITrueLayerReport[] | null;
	isLoading: boolean;
	isTrueLayerEnabled: boolean | null;
	trueLayerAuthCode: string | null;

	stripeError: string | null;
	trueLayerError: boolean | null;

	setTrueLayerReportedAccounts: (accounts: ITrueLayerReport[] | null) => void;
	setIsLoading: (isLoading: boolean) => void;
	setIsTrueLayerEnabled: (enabled: boolean) => void;
	setStripeError: (stripeError: string | null) => void;
	setTrueLayerError: (trueLayerError: boolean | null) => void;
	setTrueLayerAuthCode: (code: string | null) => void;

	reset: () => void;
}

const initialState: Pick<
	IInternalStore,
	| 'accounts'
	| 'isLoading'
	| 'stripeError'
	| 'isTrueLayerEnabled'
	| 'trueLayerAuthCode'
	| 'trueLayerError'
> = {
	accounts: null,
	isLoading: false,
	stripeError: null,
	isTrueLayerEnabled: null,
	trueLayerAuthCode: null,
	trueLayerError: null,
};

export const useInternalStore = create<IInternalStore>()((set) => ({
	...initialState,
	setTrueLayerReportedAccounts: (accounts) => set({ accounts }),
	setIsLoading: (isLoading) => set({ isLoading }),
	setIsTrueLayerEnabled: (isTrueLayerEnabled) => set({ isTrueLayerEnabled }),
	setStripeError: (stripeError) => set({ stripeError }),
	setTrueLayerAuthCode: (code) => set({ trueLayerAuthCode: code }),
	setTrueLayerError: (trueLayerError) => set({ trueLayerError }),

	reset: () =>
		set({
			accounts: initialState.accounts,
			isLoading: initialState.isLoading,
			stripeError: initialState.stripeError,
			trueLayerError: initialState.trueLayerError,
		}),
}));
